import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import React, {useEffect} from "react";
import {useForm} from "react-hook-form";
import {Disclosure} from "@headlessui/react";
import Badge from "../../components/Badge";
import SearchInput from "../../components/SearchInput";
import {AziendaSearchFormData} from "./AziendaNavContainer";
import {IconChevronUp, IconZoom} from "@tabler/icons-react";
import BuildingOffice2IconFilled from "../../icons/BuildingOffice2IconFilled";

type PropsAziendaSearchFormData = keyof AziendaSearchFormData;

interface AziendaSearchBarProps {
    azienda?: AziendaRecord,
    onSubmit: (formData: AziendaSearchFormData) => void,
    onReset: () => void,
    open: boolean,
    setOpen: (state: boolean) => void,
    selezionaAzienda: (idAzienda: number, idAziendaMaster: number) => void;
}

const AziendaSearchBar: React.FC<AziendaSearchBarProps> = ({azienda, onSubmit, onReset, open, setOpen, selezionaAzienda}) => {
    //https://tailwindui.com/components/application-ui/forms/input-groups - Input with keyboard shortcut
    /*    const ref = useHotkeys('ctrl+enter', () => {
            console.log('useHotkeys!')
            handleSubmit(onSubmit)();
        }, {
            enableOnFormTags: ['INPUT'],
            scopes: ['cercaAzienda']
        });
    */
    const defaultValues: AziendaSearchFormData = {
        codAzienda: null,
        filiale: null,
        denominazione: null,
        descrizione: null
    };
    const currentValues: AziendaSearchFormData = {
        codAzienda: azienda ? '' + azienda.codAzienda : null,
        filiale: azienda ? azienda.codFiliale : null,
        denominazione: azienda ? azienda.denominazione : null,
        descrizione: azienda ? azienda.descrizione : null
    };
    //const {register, getValues, handleSubmit, reset, formState: {errors}} = useForm<AziendaSearchFormData>(currentValues); //CON DEFAULT!!!
    const {register, getValues, setValue, handleSubmit, reset, formState: {errors}} = useForm<AziendaSearchFormData>();
    //const [open, setOpen] = useState<boolean>(false);

    useEffect(() => {
        /*
                setValue("filiale", currentValues.filiale);
                setValue("denominazione", currentValues.denominazione);
                setValue("descrizione", currentValues.descrizione);
                setValue("codAzienda", currentValues.codAzienda);
        */
        reset(currentValues);

    }, [azienda, open]);

    /*useEffect(() => {
        if (open) {
            setValue("codAzienda", currentValues.codAzienda);
            setValue("filiale", currentValues.filiale);
            setValue("denominazione", currentValues.denominazione);
            setValue("descrizione", currentValues.descrizione);
        }
    }, [open]);*/

    function searchAziendaBy(name: PropsAziendaSearchFormData) {
        const itemValue = getValues(name);
        if (itemValue && itemValue.trim().length > 0) {
            let data = {...defaultValues};
            data[name] = itemValue
            onSubmit(data);
            reset(data);
        }
    }

    return (
        <>
            {azienda &&
                <div className="my-1 rounded-lg bg-white shadow w-auto">
                    {/*<div className="rounded-lg bg-white shadow">*/}
                    <Disclosure>
                        {() => (
                            <>
                                {/* TAG MASTER + BTNS pulisci-cerca */}
                                <Disclosure.Button
                                    className="relative flex flex-row flex-wrap items-center h-auto w-full rounded-lg bg-blue-200 px-4 py-2 lg:px-6
                                               min-h-[40px]
                                               font-medium text-blue-900 text-sm max-lg:text-xs
                                               focus:outline-none focus-visible:ring focus-visible:ring-blue-500 focus-visible:ring-opacity-75"
                                    onClick={() => {
                                        if (open) onReset()
                                        setOpen(!open);
                                    }}>
                                    <a className={`w-auto ${AziendaRecord.isMaster(azienda) ? 'invisible' : ''}`} onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        selezionaAzienda(azienda.idAziendaMaster, azienda.idAziendaMaster);
                                    }}>
                                        <BuildingOffice2IconFilled className="h-5 w-5 mr-3 max-lg:mr-2"/>
                                    </a>

                                    <p className="w-auto mr-3 max-lg:mr-2">{azienda!.codAzienda}&nbsp;/&nbsp;{azienda!.codFiliale}</p>
                                    <p className="truncate max-md:max-w-xl">{azienda!.denominazione} / {azienda!.descrizione}</p>

                                    {
                                        (AziendaRecord.isMaster(azienda) || AziendaRecord.isINPS(azienda) || AziendaRecord.isINAIL(azienda)) &&
                                        <span className="w-auto inline-flex flex-wrap ml-3 max-lg:ml-0">
                                            {AziendaRecord.isMaster(azienda) && <Badge className="mr-2" label="Master"/>}
                                            {AziendaRecord.isINPS(azienda) && <Badge className="mr-2" label="INPS"/>}
                                            {AziendaRecord.isINAIL(azienda) && <Badge className="mr-2" label="INAIL"/>}
                                        </span>
                                    }

                                    <IconChevronUp
                                        className={`${open ? 'rotate-180 transform' : ''} absolute right-2 h-5 w-5 text-blue-500`}
                                    />
                                </Disclosure.Button>

                                {/* Pannello di ricerca */}
                                {open && <Disclosure.Panel className="py-4 px-6 rounded-b-lg" static>
                                    {({close}) => {
                                        return (
                                            <div>
                                                <form onSubmit={handleSubmit(onSubmit)}>
                                                    <div className="flex flex-row flex-wrap mb-4 max-sm:flex max-sm:flex-col">
                                                        <SearchInput
                                                            label="Codice azienda"
                                                            name="codAzienda"
                                                            register={register}
                                                            className="w-1/3 pr-4 max-sm:pr-0 max-sm:w-full"
                                                            searchBy={searchAziendaBy}/>
                                                        {/*{errors.userName && <p className="text-rose-700">Inserire il nome utente.</p>}*/}
                                                        <SearchInput
                                                            label="Denominazione azienda"
                                                            name="denominazione"
                                                            register={register}
                                                            className="w-2/3 max-sm:w-full"
                                                            searchBy={searchAziendaBy}/>
                                                        {/*{errors.userName && <p className="text-rose-700">Inserire il nome utente.</p>}*/}
                                                    </div>
                                                    <div className="flex flex-row flex-wrap mb-4 max-sm:flex max-sm:flex-col">
                                                        <SearchInput
                                                            label={"Codice UL"}
                                                            name="filiale"
                                                            register={register}
                                                            className="w-1/3 pr-4 max-sm:pr-0 max-sm:w-full"
                                                            searchBy={searchAziendaBy}/>
                                                        {/*{errors.userName && <p className="text-rose-700">Inserire il nome utente.</p>}*/}
                                                        <SearchInput
                                                            label={"Descrizione UL/ProvinciaRecord"}
                                                            name="descrizione"
                                                            register={register}
                                                            className="w-2/3 max-sm:w-full"
                                                            searchBy={searchAziendaBy}/>
                                                        {/*{errors.userName && <p className="text-rose-700">Inserire il nome utente.</p>}*/}
                                                    </div>

                                                    <div className="text-right col-start-3">
                                                        <button type="button"
                                                                className="inline-flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600
                                                                    max-lg:mb-1
                                                                    hover:bg-blue-700
                                                                    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
                                                                    disabled:opacity-50"
                                                                onClick={() => {
                                                                    reset(defaultValues);
                                                                    onReset();
                                                                }}>
                                                            Pulisci
                                                        </button>

                                                        <button type="submit"
                                                                className="ml-2 inline-flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600
                                                                        hover:bg-blue-700
                                                                        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
                                                                        disabled:opacity-50">
                                                            Cerca
                                                            <IconZoom className="ml-2 -mr-0.5 h-5 w-5" aria-hidden="true"/>
                                                        </button>
                                                    </div>
                                                </form>
                                                <div>{azienda.idAzienda}/{azienda.idAziendaMaster}</div>
                                            </div>
                                        )
                                    }}
                                </Disclosure.Panel>}
                            </>)}
                    </Disclosure>
                </div>
            }
        </>
    )
}
export default AziendaSearchBar;